import _ from "lodash"

import { useAppSelector } from "../app/hooks"
import { IAvailabilitySelectorValues } from "../components/AvailabilitySelector"
import { IFlightSelectorValues } from "../components/FlightSelector"
import { IFlightSelection } from "../containers/selectionSlice"

export const useFlightSelectorStateValues = () => {
  const flightSelection: IFlightSelection = useAppSelector(
    (state) => state["selectionReducer"].flightSelector
  )

  let initialState = useFlightSelectorInitValues()

  Object.keys(initialState).forEach((key) => {
    const flightSelectionVal = flightSelection.values[key]
    const flightSelectorStateVal = initialState[key]
    if (
      flightSelectionVal != null &&
      !_.isEqual(flightSelectionVal, flightSelectorStateVal)
    ) {
      initialState[key] = flightSelectionVal
    }
  })

  return initialState
}

export const useFlightSelectorInitValues = (): IFlightSelectorValues => {
  let initialState = {
    operators: [],
    excludeOper: false,
    doop: "",
    aircraftType: "",
    aircraftRegistration: "",
    startDate: null,
    endDate: null,
    flightMode: "",
    clearCode: "",
    clearedTimeFrom: "",
    clearedTimeTo: "",
    requiredTimeFrom: "",
    requiredTimeTo: "",
    origDest: "",
    prevNext: "",
    terminal: "",
    serviceNumber: "",
    serviceNumberTo: "",
    serviceTypes: [],
    delink: false,
    normalizePeriod: false,
    waitlist: false,
    excludeNoslots: false,
    noslotsOnly: false,
    lastUpdate: null,
    canxSinceDate: null,
    viewRestricted: false,
    useOwnOperators: false,
    viewSubmittedShl: false,
    slotId: "",
    handler: "",
    flightRule: "",
    towbar: "",
    parkingLocation: "",
    noiseCertificate: ""
  }

  return initialState
}

export const useAvailabilitySelectorStateValues =
  (): IAvailabilitySelectorValues => {
    const slotAvailabilitySelector = useAppSelector(
      (state) => state["selectionReducer"].slotAvailabilitySelector
    )

    let initialState = useAvailabilitySelectorInitValues()

    Object.keys(initialState).forEach((key) => {
      const availSelectionVal = slotAvailabilitySelector.values[key]
      const availSelectorStateVal = initialState[key]
      if (
        availSelectionVal != null &&
        !_.isEqual(availSelectionVal, availSelectorStateVal)
      ) {
        initialState[key] = availSelectionVal
      }
    })

    return initialState
  }

export const useAvailabilitySelectorInitValues =
  (): IAvailabilitySelectorValues => {
    let initialState = {
      constraintType: "Runway",
      valueType: "availability",
      operators: [],
      terminal: "",
      adt: "L",
      dayOfWeek: "1",
      hour: "00",
      date: null,
      useHourlyConstraints: true,
      mergeTotals: true,
      overlayQuotaConstraints: false,
      schedule: "live"
    }

    return initialState
  }
